import React, {useState} from 'react';
import TextInput from '../../common/component/form/TextInput';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {Redirect, useHistory} from 'react-router-dom';
import '../style/Login.less';
import StacyLogo from '../../common/img/stacy-logo.svg';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {createErrorMessage, handleEmailChange} from '../util/AccountUtil';
import {command} from '../../common/util/DispatchUtil';

function AccountSettings() {
    const history = useHistory();
    const isLoggedIn = useSelector(state => state.account.isLoggedIn);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [validation, setValidation] = useState({
        email: true,
        password: true
    });
    const [t] = useTranslation();
    const dispatch = useDispatch();
    const [loginError, setLoginError] = useState();
    const [firstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [shortName, setShortName] = useState('');

    if (!isLoggedIn) {
        return <Redirect to={{pathname: '/'}}/>;
    }

    function isValid() {
        const newValidation = {
            email: !!email,
            password: !!password
        };
        setValidation(newValidation);
        return Object.values(newValidation).every(field => !!field);
    }

    return (
        <>
            <div className="popup">
                <div className="popup_inner">
                    <div className="popup_container">
                        {/* Headline and Picture */}
                        <div className="">
                            <h1 className="">
                                {t('AccountSettings.TITLE')}
                            </h1>
                            <img src={StacyLogo} alt="Profile Picture"/>
                        </div>
                        {/* Inputs */}
                        <div className="big-label">
                            {/* left inputs */}
                            <div className="">
                                <TextInput
                                    id="first_name"
                                    value={firstName}
                                    label={t('Login.FIRST_NAME')}
                                    onChange={(value) => {
                                        handleEmailChange(value, setEmail, setLoginError);
                                    }}
                                    required={true}
                                    isValid={true}
                                    focusOnLoad={true}
                                    autoComplete={t('Login.FIRST_NAME')}
                                    errorMessage={createErrorMessage(loginError)}
                                />
                                <TextInput
                                    id="short_name"
                                    value={shortName}
                                    label={t('Login.SHORT_NAME')}
                                    type="password"
                                    onChange={setShortName}
                                    required={true}
                                    isValid={true}
                                    autoComplete={t('Login.SHORT_NAME')}
                                />
                                <TextInput
                                    id="password"
                                    value={password}
                                    label={t('Login.PASSWORD')}
                                    type="password"
                                    onChange={setPassword}
                                    required={true}
                                    isValid={validation.password}
                                    autoComplete="password"
                                />
                            </div>
                            {/* right inputs */}
                            <div className="">
                                <TextInput
                                    id="last_name"
                                    value={lastName}
                                    label={t('Login.LAST_NAME')}
                                    type="last_name"
                                    onChange={setLastName}
                                    required={true}
                                    isValid={true}
                                    autoComplete={t('Login.LAST_NAME')}
                                />
                                <TextInput
                                    id="username"
                                    value={email}
                                    label={t('Login.EMAIL')}
                                    onChange={handleEmailChange}
                                    required={true}
                                    isValid={validation.email && !loginError}
                                    focusOnLoad={true}
                                    autoComplete="email"
                                    errorMessage={t('Error.INVALID_AUTHENTICATION')}
                                />
                                <link/>
                            </div>
                        </div>
                        {/* Buttons */}
                        <div className="">
                            <button
                                className="btn btn-transparent-primary mr-3"
                                onClick={() => {
                                    dispatch(command('SHOW_NAVBAR'));
                                    history.push('/');
                                }}>
                                <FontAwesomeIcon icon="times" className="mr-2"/>
                                {t('Button.CANCEL')}
                            </button>
                            <button
                                className={isValid() ? "btn btn-primary" : "btn btn-disabled"}
                                onClick={() => {
                                    if (isValid()) {
                                        dispatch(command('SHOW_NAVBAR'));
                                        history.push('/');
                                    }
                                }}>
                                <FontAwesomeIcon icon="check" className="mr-2"/>
                                {t('Button.SAVE')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AccountSettings;
